<template>
    <div id="content" v-show="!loading">
        <popup v-show="hasPopup"
               :popup-type="getPopupType"
               :popup-action="getPopupAction"
               @popup-action="executePopupAction"></popup>
        <form>
            <div class="inner">
              <p class="paging">
                  <router-link :to="{ name: moduleName }" class="btn btn_back" v-translate>Seznam</router-link>
              </p>
              <p class="buttons" v-if="isEditable">
                <a v-if="$_deleteActionAllowed" class="btn btn_action btn_delete" :title="'Smazat' | translate"
                  @click.prevent.stop="deleteEntity" v-translate>Smazat</a>
              </p>
              <h1 v-if="entity.name">{{ entity.name }}</h1>
            </div>

            <div class="responsiveTabs">
              <div class="tabs_content">
                <section v-show="$_readActionAllowedAllOrOwnAndGlobal">
                  <div class="left">
                    <h2 v-translate>Výběr operátora</h2>
                  </div>
                  <div class="right">
                    <div class="field_left">
                      <operator-select
                          v-model="operatorIdComputed"
                          :options="operatorOptions"
                          :disabled="true"
                      >
                      </operator-select>
                    </div>
                  </div>
                </section>
                <section>
                  <div class="left">
                    <detail-entity-info :entity="entity"></detail-entity-info>
                  </div>
                  <stream-profile-basic-form
                    :entity="entity"
                    :is-editable.sync="isEditable"
                    ref="streamprofileformref"
                  ></stream-profile-basic-form>
                </section>
                <section>
                  <div class="left">
                    <h2 v-translate>Muxovací maska</h2>
                  </div>
                  <stream-profile-mux-mask
                      :entity="entity"
                      :is-editable.sync="isEditable"
                      ref="streamprofilemuxmaskformref"
                  ></stream-profile-mux-mask>
                </section>
                <stream-profile-metadata-form
                  :entity="entity"
                  :is-editable.sync="isEditable"
                  ref="streamprofilemetadataformref"
                />
                <section>
                  <div class="left">
                    <h2 v-translate>Backend konfigurace</h2>
                  </div>
                  <div class="right">
                    <div class="field">
                      <JSONTextareaInput
                          v-model="entity.backend_config"
                          rows="15"
                          :disabled="!isEditable"
                      >
                        <translate class="translate">JSON konfigurace</translate>
                      </JSONTextareaInput>
                    </div>
                  </div>
                </section>
                <section class="buttons" v-if="isEditable">
                    <p>
                        <router-link :to="{ name: moduleName }" class="btn btn_back btn_seznam" v-translate>Seznam
                        </router-link>
                        <input
                            v-if="$_updateActionAllowed"
                            type="submit" :value="'Uložit' | translate"
                               :class="['btn']"
                               @click.prevent.stop="submitForm()">
                    </p>
                </section>
              </div>
            </div>
        </form>
    </div>
</template>

<script>
	import StreamProfileBasicForm from "@/components/views/streamProfiles/forms/StreamProfileBasicForm"
  import StreamProfileMetadataForm from "@/components/views/streamProfiles/forms/StreamProfileMetadataForm"
  import StreamProfileMuxMask from "@/components/views/streamProfiles/forms/StreamProfileMuxMask"
	import detailActions from "@/components/mixins/detail-actions"
	import streamProfiles from "@/components/views/streamProfiles/mixins/streamProfiles"
  import JSONTextareaInput from "../../common/JSONTextareaInput";

	export default {
		name: "StreamProfileDetail",
		components: {
      StreamProfileBasicForm,
      StreamProfileMetadataForm,
      StreamProfileMuxMask,
      JSONTextareaInput
    },
		mixins: [detailActions, streamProfiles],
		created(StreamProfileService, OperatorService) {
			this.entityService = StreamProfileService

      if (this.$_readActionAllowedAllOrOwnAndGlobal) {
        this.operatorService = OperatorService
        this.getOperators(true)
      }

			this.createdInit()
		},
    computed: {
      isEditable() {
        return this.$_updateActionAllowed;
      },
    },
		methods: {
			getEntity() {
				this.setLoadingMessage()

				return this.entityService.getEntity(this.$route.params.id, {id_selected_operator: this.$_loggedUser_selectedOperatorId})
					.then(data => {
						this.entity = data.streamProfile
						this.emptyMessage()
					})
					.then(() => {
            this.$refs['streamprofilemuxmaskformref'].createSelectionFromMuxMask();
						this.$refs['streamprofileformref'].validateStreamProfileFormRequiredFields()
					})
					.catch(function (error) {
						this.setErrorMessage(error['error_message'])
					}.bind(this))
			},
			updateEntity(params, redirect = false) {
				this.entityService.updateEntity(this.entity.id, this.filterFormParams({...params}))
					.then(() => {
						if (redirect === true) {
							this.redirect(this.moduleName)
						} else {
							this.emptyMessage()
							this.getEntity()
                  .then(() => {
                this.setSuccessMessage()
              })
						}
					})
					.catch(function (error) {
						this.setErrorMessage(this.processErrorMessage(error))
					}.bind(this))
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/views/streamProfiles/StreamProfileDetail.vue